module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_1.1179fce9.pdf";